import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from "../icon/icon.component.jsx"
import Integrations from "../../integration/Integrations.jsx"
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {STOCK_DOCUMENTS} from "../../utils/inventory"

const uuidv4 = require('uuid/v4')

class QuoteItemInventoryRequested extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            item: this.props.value || null,
            type: this.props.type || 'quote',
            editable: this.props.editable || false,
            uniqueId: uuidv4(),
            onChange: this.props.onChange || function () { },
            modal: '',
            mainObjectId: this.props.mainObjectId || '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            item: nextProps.value || null,
            mainObjectId: nextProps.mainObjectId || '',
        })
    }

    render() {
        if (!this.state.item) {
            return null
        }
        const prod = this.state.item.attributes.itemObject
        const inventoryRequestedMeasure = parseFloat(this.state.item.attributes.inventoryRequestedMeasure)
        const inventoryReceivedMeasure = parseFloat(this.state.item.attributes.inventoryReceivedMeasure)
        if (prod.type !== 'products' || inventoryRequestedMeasure === 0) {
            return null
        }
        let color = (inventoryReceivedMeasure === inventoryRequestedMeasure) ? 'success' : 'warning'
        let poNumber = ''
        if (this.state.item.attributes.externalPurchaseOrder) {
            poNumber =
                <a href={Integrations.getExternalPurchaseOrderUrl(this.state.item.attributes.externalPurchaseOrder)}
                   target={'_blank'}>
                    (<FormattedMessage
                    id="quote.edit.inventory.po_number"
                    defaultMessage="PO #{number}"
                    values={{
                        number: Integrations.getShortenedPONumber(this.state.item.attributes.externalPurchaseOrder),
                    }}
                />)
                </a>
        } else if (this.state.item.attributes.references?.length > 0) {
            const ref = this.state.item.attributes.references.find(ref => ref.attributes.referenceKey === STOCK_DOCUMENTS)
            if (!ref) {
                return null
            }
            poNumber =
                <a href={`/stock-documents/${ref.attributes.referenceId}/edit`} target={'_blank'}>
                    {ref.attributes.referenceIdentifier}
                </a>
        } else {
            return null
        }
        return <div className={"" + this.state.className}>
            <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                overlay={
                    <Tooltip
                        tooltipId={`tooltip_requested_inventory${this.state.item.id ?? ""}`}
                    >
                        <FormattedMessage
                            id="quote.edit.inventory.requested_items"
                            defaultMessage="{count}/{total} received {poNumber}"
                            values={{
                                count: inventoryReceivedMeasure,
                                total: inventoryRequestedMeasure,
                                poNumber: poNumber,
                            }}
                        />
                    </Tooltip>}
            >
                <span
                    id={this.state.uniqueId}
                    className={'badge badge-pill badge-' + color}>
                    <Icon value={'truck-moving'} className={"px-1"} />
                    <FormattedMessage
                        id="quote.edit.inventory.requested_items_short"
                        defaultMessage="{count}/{total} {poNumber}"
                        values={{
                            count: inventoryReceivedMeasure,
                            total: inventoryRequestedMeasure,
                            poNumber: poNumber,
                        }}
                    />
                </span>
            </OverlayTrigger>
        </div>

    }

}

export default QuoteItemInventoryRequested





// WEBPACK FOOTER //
// ./src/common/quote/iteminventoryrequested.component.jsx